/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2022-08-12 14:22:11
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'

import BsyFilterBase from '../BsyFilterBase';
import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterFile extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            ...props
        })

        this.dashText = null;
    }

    _getAvailableMethods = () => {
        return [BsyConfig().CONST.FILTER_METHOD.EP, BsyConfig().CONST.FILTER_METHOD.NEP]
    }


    getValue = () => {
        return null
    }

    getContext = (e) => {
        this.dashText = e;
    }

    renderCont = () => {


    }

    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

